import { render, staticRenderFns } from "./IrrPublishRequestListComponent.vue?vue&type=template&id=4eebfcd2"
import script from "./IrrPublishRequestListComponent.vue?vue&type=script&lang=js"
export * from "./IrrPublishRequestListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports